import React from "react"
import { useFilterOptions } from "../../hooks"
import { StyledBlogFilterCategory } from "../../styled"

const DesktopOptionsFilter = () => {
  const { filterOptions } = useFilterOptions()
  return (
    <>
      <StyledBlogFilterCategory>Category</StyledBlogFilterCategory>
      {filterOptions}
    </>
  )
}

export default DesktopOptionsFilter
